var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "onboarding-network-selector" }, [
    _c(
      "div",
      { staticClass: "onboarding-networks-grid" },
      _vm._l(_vm.networks, function (network) {
        return _c(
          "div",
          {
            key: network.id,
            staticClass: "onboarding-network-item",
            class: {
              selected: _vm.isSelected(network.id),
              disabled: network.disabled,
            },
            on: {
              click: function ($event) {
                return _vm.toggleNetwork(network)
              },
            },
          },
          [
            _c("div", { staticClass: "onboarding-network-icon-wrapper" }, [
              _c("img", {
                staticClass: "onboarding-network-icon",
                attrs: { src: network.icon, alt: network.name },
              }),
            ]),
            _c("span", { staticClass: "onboarding-network-name" }, [
              _vm._v(_vm._s(network.name)),
            ]),
            _c("div", {
              staticClass: "onboarding-network-check",
              class: { checked: _vm.isSelected(network.id) },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }